import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// Personal Evaluation Component
    //////////////////////////////////////

    if (action === 'saveTypeOfWork') {
        cfObj.fieldName = 'typeOfWork';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personalEvaluation';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveIndustry') {
        cfObj.fieldName = 'industry';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personalEvaluation';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveLocation') {
        cfObj.fieldName = 'location';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personalEvaluation';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'savePESkipped') {
        cfObj.fieldName = 'skipped';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personalEvaluation';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'savePESubmitted') {
        cfObj.fieldName = 'submitted';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personalEvaluation';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const localPersonalEvaluationData = payload.localPersonalEvaluationData;
    const userId = payload.userId;

    const cfObj = checkInputFieldService(localPersonalEvaluationData, action);
    
    // // console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    // // console.log("executing...", localPersonalEvaluationData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};
    dataObj["_id"] = localPersonalEvaluationData._id;
    dataObj['collectionName'] = cfObj.collectionName;

    if (localPersonalEvaluationData[`${fieldName}`]) { // If field value is not null
        
        if(isInteger(localPersonalEvaluationData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localPersonalEvaluationData[`${fieldName}`].toString().trim());
        } if(isBoolean(localPersonalEvaluationData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localPersonalEvaluationData[`${fieldName}`].toString().trim());
        } else {
            dataObj[`${fieldName}`] = localPersonalEvaluationData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null

    // // console.log(dataObj);

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}